import React from "react";
import { Tag } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileSearchOutlined,
  CarOutlined,
  ExclamationCircleOutlined,
  TruckOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

export default function MarketplaceStatus(props) {
  const { status } = props;

  if (typeof status !== "number") {
    return (
      <Tag color="red" icon={<CloseCircleOutlined />}>
        Inválido
      </Tag>
    );
  }

  const statusList = {
    1: {
      icon: <FileSearchOutlined />,
      color: "purple",
      text: "Aceptada",
    },
    2: {
      icon: <CarOutlined />,
      color: "orange",
      text: "En camino",
    },
    3: {
      icon: <CheckCircleOutlined />,
      color: "green",
      text: "Entregada",
    },
    4: {
      icon: <CloseCircleOutlined />,
      color: "red",
      text: "Cancelada",
    },
    5: {
      icon: <CloseCircleOutlined />,
      color: "volcano",
      text: "Rechazada",
    },
    9: {
      icon: <ExclamationCircleOutlined />,
      color: "cyan",
      text: "Pendiente",
    },
    10: {
      icon: <TruckOutlined />,
      color: "blue",
      text: "Guía Generada",
    },
  };

  const currentStatus = statusList[status] || {
    icon: <FileSearchOutlined />,
    color: "default",
    text: `Desconocido (${status})`,
  };

  return (
    <Tag icon={currentStatus.icon} color={currentStatus.color}>
      {currentStatus.text}
    </Tag>
  );
}
